module.exports = __webpack_public_path__ + "img/zgyd.31586d45.png";